import React from 'react';
import IframePage from "../iframe-page/iframe-page";
import config from "../../config";

const AnalyticsOrdersPage: React.FC = () => {
    return (
        <IframePage url={`${config.apiUrl}/dashboard/analytics/orders`} />
    );
}

export default AnalyticsOrdersPage;